
/* injects from baggage-loader */

'use strict';

export default class DialogAlertController {
	constructor($log) {
		'ngInject';
		this.$log = $log;
	}

	$onInit() {
		this.alertText = "<b>Reveja sua resposta.</b> Acho que algo está incorreto.";
		this.$log.debug(this);
	}

	ok(){
		this.modalInstance.close(true);
	}

	cancel(){
		this.modalInstance.dismiss('cancel');
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/alert/alert.controller.js